document.addEventListener("DOMContentLoaded", function () {
    const thumbnail = document.querySelector("#video-popup-thumbnail");
    const popup = document.querySelector("#video-popup");
    const bodyOverlay = document.querySelector(".body-overlay");
    const closeBtn = popup ? popup.querySelector(".icon-close") : null;
    const htmlEl = document.documentElement; // <html> elementet

    function isOpen() {
        return !popup.classList.contains("hidden");
    }

    function openPopup() {
        popup.classList.remove("hidden");
        htmlEl.classList.add("flyout-open");
        bodyOverlay.classList.add("active");
        thumbnail.setAttribute("aria-expanded", "true");

        // Flytta fokus in i popupen så att tangentbordsanvändare hamnar vid videon
        if (closeBtn) {
            closeBtn.focus();
        }
    }

    function closePopup() {
        if (!isOpen()) {
            return;
        }

        popup.classList.add("hidden");
        htmlEl.classList.remove("flyout-open");
        bodyOverlay.classList.remove("active");
        thumbnail.setAttribute("aria-expanded", "false");

        // Stoppa videon genom att ladda om iframen
        const iframe = popup.querySelector("iframe");
        if (iframe) {
            iframe.src = iframe.src;
        }

        // Lämna tillbaka fokus till miniatyren
        thumbnail.focus();
    }

    // Enter/mellanslag ska fungera som klick på element med role="button"
    function onActivateKey(callback) {
        return function (e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                callback();
            }
        };
    }

    if (thumbnail && popup && bodyOverlay) {
        thumbnail.setAttribute("aria-expanded", "false");

        thumbnail.addEventListener("click", function (e) {
            e.preventDefault();
            openPopup();
        });
        thumbnail.addEventListener("keydown", onActivateKey(openPopup));

        if (closeBtn) {
            closeBtn.addEventListener("click", function (e) {
                e.preventDefault();
                closePopup();
            });
            closeBtn.addEventListener("keydown", onActivateKey(closePopup));
        }

        bodyOverlay.addEventListener("click", function (e) {
            e.preventDefault();
            closePopup();
        });

        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape" && isOpen()) {
                closePopup();
            }
        });

        // Håll fokus inom popupen medan den är öppen
        popup.addEventListener("keydown", function (e) {
            if (e.key !== "Tab") {
                return;
            }

            const focusable = popup.querySelectorAll('iframe, [tabindex="0"], a[href], button');
            if (!focusable.length) {
                return;
            }

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        });
    }
});

//# sourceMappingURL=video-popup.js.map
